import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';

interface UpdateAutomationReportStepDueDateParams {
	stepStatusId: string;
	dueDate?: string;
}

export const useUpdateAutomationReportStepDueDateMutation = () => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ stepStatusId, dueDate }: UpdateAutomationReportStepDueDateParams) => {
			const url = Api.ImpersonationBroker.composeApiUrl({
				queryParams: dueDate ? { dueDate } : undefined,
				urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}/DueDate`,
			});

			return userSession.webServiceHelper.callAsync<Api.IAutomation>(url, 'PUT', null);
		},
	});
};
